import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BackButton } from "../../../components/buttons/backButton";
import { ForgotPasswordCreate } from "./forgotPasswordCreateForm";
import { ForgotPasswordDetails } from "./forgotPasswordDetailsForm";

export const ForgotPassword = () => {
  const [step, setStep] = useState(1);

  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  useEffect(() => {
    if (searchParams.get("step") === "activateAccount") {
      setStep(() => 2);
    }
  }, [searchParams]);

  return (
    <div className="w-full max-w-[327px] flex flex-col gap-7">
      {searchParams.get("step") !== "activateAccount" && (
        <BackButton
          text={step > 1 ? "Forgot Password" : "Back"}
          onClick={() => {
            if (step > 1) {
              setStep(step - 1);
            } else {
              navigate("/auth/sign-in");
            }
          }}
        />
      )}

      {step === 1 && <ForgotPasswordDetails setStep={setStep} />}

      {step === 2 && <ForgotPasswordCreate setStep={setStep} />}
    </div>
  );
};
